import logger from './logger';

export default function KioAppHelper<T extends keyof KioApp>(methodName: T, ...args: Parameters<KioApp[T]>): ReturnType<KioApp[T]> | null {
	if (!isKioAppAvailable()) return null;
	try {
		const kio = KioApp;
		const method = kio[methodName];
		// logger.debug.log(`KioAppHelper: Calling method ${String(methodName)} with arguments:`, args); // Removing due to the amount of noise on the console
		if (typeof method === 'function') return Function.prototype.call.apply(method, [kio, ...args]) as ReturnType<KioApp[T]>;
		return null;
	} catch (error) {
		if (import.meta.env.DEV && import.meta.env.VITE_DISABLE_DEV_KIOAPP_WARNINGS) return null;
		else if (import.meta.env.DEV) logger.debug.warn(`Error calling method ${String(methodName)}:${error}`);
		else logger.debug.error(`Error calling method ${String(methodName)}:`, error);
		return null;
	}
}

export function isKioAppAvailable(): boolean {
	try {
		return typeof KioApp !== 'undefined' && KioApp !== null;
	} catch {
		return false;
	}
}
